<template>
  <!-- 轮播图 -->
  <div class="carousel">
    <el-carousel arrow="always" :autoplay="true" height="371px" interval="2000">
      <el-carousel-item v-for="item in scrollingBannerList" :key="item.id">
        <router-link :to="item.hyperlink">
          <img :src="Upload.getImgUrl(item.imgSource)" />
        </router-link>
      </el-carousel-item>
    </el-carousel>
  </div>

  <!-- 教育产品 -->
  <div class="product_1 page-part-bg-color">
    <div class="wrap">
      <div class="page-part-title">教育产品</div>
      <div class="product-features">
        <div
          v-for="feature in educationFeatures"
          :key="feature.title"
          class="feature-item"
        >
          <div class="feature-box">
            <div class="feature-image" :class="feature.bgClass"></div>
            <div class="feature-content">
              <h4>{{ feature.title }}</h4>
              <p>{{ feature.description }}</p>
              <!-- <a :href="feature.href" class="more-button">查看更多</a> -->
              <router-link :to="feature.href" class="more-button"
                >查看更多</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 产品优势 -->
  <div class="product_2">
    <div class="wrap">
      <div id="advance" class="page-part-title">产品优势</div>
      <div class="product-advantages">
        <div
          v-for="advantage in productAdvantages"
          :key="advantage.title"
          class="advantage-item"
        >
          <div class="advantage-box" :class="advantage.bgClass">
            <h4>{{ advantage.title }}</h4>
            <p>{{ advantage.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 合作院校 -->
  <div class="cooperateSchool page-part-bg-color">
    <div class="wrap">
      <div
        class="page-part-title wow rollIn"
        data-wow-duration="1s"
        data-wow-delay="1s"
      >
        合作院校-本科
      </div>
      <div class="school-features">
        <div
          v-for="school in schools"
          :key="school"
          class="school-item wow rollIn"
          data-wow-duration="1s"
          data-wow-delay="1s"
        >
          <div
            class="school-box"
            :class="'school-bg-' + school"
            :data-title="schoolNames[school]"
          ></div>
        </div>
      </div>
      <div
        class="page-part-title wow rollIn"
        data-wow-duration="1s"
        data-wow-delay="1s"
        style="margin-top: -10px"
      >
        合作院校-高职中专
      </div>
      <div class="school-features">
        <div
          v-for="school in vocationalSchools"
          :key="school"
          class="school-item wow rollIn"
          data-wow-duration="1s"
          data-wow-delay="1s"
        >
          <div
            class="school-box"
            :class="'school-bg-' + school"
            :data-title="vocationalSchoolsschoolNames[school]"
          ></div>
        </div>
      </div>
    </div>
  </div>

  <!-- 合作生态 -->
  <!-- <div class="ecology">
    <div class="wrap">
      <div class="page-part-title">合作生态</div>
      <div class="ecology-features">
        <div
          v-for="ecology in ecologies.slice(0, 3)"
          :key="ecology"
          class="ecology-item"
        >
          <div class="ecology-box" :class="'ecology-bg-' + ecology"></div>
        </div>
        <div
          v-for="ecology in ecologies.slice(3, 5)"
          :key="ecology"
          class="ecology-item"
        >
          <div class="ecology-box" :class="'ecology-bg-' + ecology"></div>
        </div>
        <div
          v-for="ecology in ecologies.slice(5)"
          :key="ecology"
          class="ecology-item"
        >
          <div class="ecology-box" :class="'ecology-bg-' + ecology"></div>
        </div>
      </div>
    </div>
  </div> -->
  <div class="ecology">
    <div class="wrap">
      <div class="page-part-title">合作生态</div>
      <div class="ecology-features">
        <!-- 第一排 -->
        <div
          v-for="ecology in ecologies.slice(0, 3)"
          :key="ecology"
          class="ecology-item wow rollIn"
          data-wow-duration="1s"
          data-wow-delay="1s"
        >
          <div
            class="ecology-box"
            :class="'ecology-bg-' + ecology"
            :data-title="ecologyNames[ecology]"
          ></div>
        </div>
        <!-- 第二排 -->
        <div
          v-for="ecology in ecologies.slice(3, 5)"
          :key="ecology"
          class="ecology-item wow rollIn"
          data-wow-duration="1s"
          data-wow-delay="1s"
        >
          <div
            class="ecology-box"
            :class="'ecology-bg-' + ecology"
            :data-title="ecologyNames[ecology]"
          ></div>
        </div>
        <!-- 第三排 -->
        <div
          v-for="ecology in ecologies.slice(5)"
          :key="ecology"
          class="ecology-item wow rollIn"
          data-wow-duration="1s"
          data-wow-delay="1s"
        >
          <div
            class="ecology-box"
            :class="'ecology-bg-' + ecology"
            :data-title="ecologyNames[ecology]"
          ></div>
        </div>
      </div>
    </div>
  </div>

  <!-- 新闻动态 -->
  <div class="news">
    <div class="wrap">
      <div class="page-part-title">新闻动态</div>
      <div class="news-list">
        <div v-for="item in newdynallist" :key="item.id" class="news-item">
          <img
            :src="Upload.getImgUrl(item.homeImgSource)"
            :alt="item.title"
            class="news-image"
          />
          <div class="news-info">
            <router-link :to="'/NewsDetail/' + item.id" class="news-title">{{
              item.title
            }}</router-link>
            <div class="news-date">发布时间：{{ item.publicationDate }}</div>
          </div>
        </div>
        <div class="more-info-btn-container">
          <!-- target="_blank" -->
          <!-- <a href="/News" class="more-info-btn" >更多资讯</a> -->
          <router-link to="/News" class="more-info-btn">更多资讯</router-link>
        </div>
      </div>
    </div>
  </div>
  <div class="image">
    <div class="text-container">
      <div class="company-name">晨鸟科技</div>
      <div class="expertise">数字教育服务专家</div>
    </div>
  </div>
</template>

<script>
import WOW from "wow.js";
// @ is an alias to /src
export default {
  data() {
    return {
      animatedSchools: {},
      //轮播图
      scrollingBannerList: [],
      //新闻动态
      newdynallist: [],
      // 产品优势
      productAdvantages: [
        {
          title: "严肃游戏教学",
          description:
            "基于先进的严肃游戏教学理论，采用游戏化盘面/界面设计，融入竞争博弈、即时奖励、成就系统等丰富的游戏元素，寓教于乐，在趣味操作中实践学习，迎合新一代学生兴趣。",
          bgClass: "bg-img-1",
        },
        {
          title: "沉浸互动教学",
          description:
            "学生在仿真场景中与教师、同组同学共同沉浸，积极参与交流、沟通、协商、探讨，与不同小组进行游戏博弈，通过不同决策竞争获取最大资源，改善传统上机实验、实训枯燥乏味现状。",
          bgClass: "bg-img-2",
        },
        {
          title: "前沿技术赋能",
          description:
            "将AIGC（生成式人工智能）、区块链、大数据、物联网等前沿技术在行业中的应用场景融入实验实训产品，帮助学生熟练应用AIGC等前沿技术提高业务效率，为其将来工作打下坚实基础。",
          bgClass: "bg-img-3",
        },
      ],
      // 教育产品
      educationFeatures: [
        {
          title: "营运博奔沙盘产品",
          description:
            "面向旅游、酒店、会展、餐饮、民宿、康养、研学、电商、跨境电商、物流、金融等高职本科专业的系列仿真博弈沙盘产品，基于严肃游戏理论，采用多点触控沙盘软件技术，将业务场景逐一呈现、融汇贯通，全面实现趣味性、真实性、实用性、互动性四位一体。",
          bgClass: "education-bg-1",
          // 跳转地址
          href: "/EducationalProducts#Simulate",
        },
        {
          title: "创新创业产品",
          description:
            "囊括电子商务、数字旅游、移动应用等创新创业模式。创业团队通过系统地创业能力培训和行业能力实践，在平台上进行创业实战和试水。通过对实际问题的遭遇和解决，在创业过程中迭代式地进行再培训，逐步使创业团队形成成熟、强健的核心竞争力和盈利模式。",
          bgClass: "education-bg-2",
          href: "/EducationalProducts#innovation",
        },
        {
          title: "赋能产品",
          description:
            "基于生成式人工智能、区块链、大数据、情感识别、语义分析等技术，研发形成沙盘精灵、数字助教情感识别、数字化竞赛管理等教学和竞赛赋能产品，辅助提高教学效率、教学质量和竞赛管理水平。",
          bgClass: "education-bg-3",
          href: "/EducationalProducts#enabling",
        },
      ],
      // 合作院校-本科
      schools: [
        "fudan",
        "huaqing",
        "huanan",
        "shanghaishifan",
        "shenzhen",
        "sanda",
        "taizhou",
        "zhanjiang",
        "huangshan",
        "luoyangshifan",
        "guilinlvyou",
        "foshan",
        "baise",
        "maotai",
        "chongqing",
        "shanghailida",

        "lijiang",
        "huaibei",
        "kashi",
        "fujian",
        "jinhua",
        "beifang",
        "sanming",
        "hulunbeier",
      ],
      // 合作院校-高职
      vocationalSchools: [
        "shandong",
        "hebei",
        "shanghailvyou",
        "zhangzhou",
        "beijing",
        "chongqinggongshang",
        "guangzhou",
        "hainan",
        "qingdao",
        "tongren",
        "ningbo",
        "zhengzhoulvyou",
        "shanxilvyou",
        "yantaiwenhua",
        "jilin",
        "sichuanhuagong",

        "guangxishangwu",
        "tianjing",
        "anhuigongshang",
        "hainanruanjian",
        "wuhanjiaotong",
        "bozhou",
        "shanghaijiguang",
        "shanghaizhenhua",
        "xiamenhaiyang",
        "fujianxinxi",
        "guangdongkexue",
        "taizhoukeji",
      ],
      // 合作生态
      ecologies: [
        "lvyoubu",
        "jiaoyubu",
        "fujian",
        "fudan2",
        "huaqiao",
        "fandian",
        "gansu",
        "fudan1",
      ],
      //本科
      schoolNames: {
        fudan: "复旦大学",
        huaqing: "华侨大学",
        huanan: "华南理工大学",
        shanghaishifan: "上海师范大学",
        shenzhen: "深圳大学",
        sanda: "上海杉达学院",
        taizhou: "台州学院",
        zhanjiang: "湛江科技学院",
        huangshan: "黄山学院",
        luoyangshifan: "洛阳师范学院",
        guilinlvyou: "桂林旅游学院",
        foshan: "佛山科学技术学院",
        baise: "百色学院",
        maotai: "茅台学院",
        chongqing: "重庆第二师范学院",
        shanghailida: "上海立达学院",
        lijiang: "丽江文化旅游学院",
        huaibei: "淮北师范大学",
        kashi: " 喀什大学",
        fujian: "福建商学院",
        jinhua: "金华职业技术大学",
        beifang: "河北北方学院",
        sanming: "三明学院",
        hulunbeier: "呼伦贝尔学院",
      },
      //高职
      vocationalSchoolsschoolNames: {
        shandong: "山东旅游职业学院",
        hebei: "河北旅游职业学院",
        shanghailvyou: "上海旅游高等专科学院",
        zhangzhou: "漳州职业技术学院",
        beijing: "北京工业职业技术学院",
        chongqinggongshang: "重庆工商职业学院",
        guangzhou: "广州番禺职业技术学院",
        hainan: "海南经贸职业技术学院",
        qingdao: "青岛酒店管理职业技术学院",
        tongren: "铜仁职业技术学院",
        ningbo: "宁波东钱湖旅游学校",
        shanxilvyou: "山西艺术职业学院",
        yantaiwenhua: "烟台文化旅游职业技术学院",
        jilin: "吉林工程职业学院",
        sichuanhuagong: "四川化工职业技术学院",
        zhengzhoulvyou: "郑州旅游职业学院",
        guangxishangwu: "广西国际商务职业技术学院",
        tianjing: "天津职业大学",
        anhuigongshang: "安徽工商职业学院",
        hainanruanjian: "海南软件职业技术学院",
        wuhanjiaotong: "武汉交通职业学院",
        bozhou: "亳州职业技术学院",
        shanghaijiguang: "上海济光职业技术学院",
        shanghaizhenhua: "上海振华外经职业技术学院",
        xiamenhaiyang: "厦门海洋职业技术学院",
        fujianxinxi: "福建信息职业技术学院",
        guangdongkexue: "广东科学技术职业学院",
        taizhoukeji: "台州科技学院",
      },
      ecologyNames: {
        lvyoubu: "中华人民共和国文化和旅游局",
        jiaoyubu: "中华人民共和国教育部",
        fujian: "福建省教育厅",
        fudan2: "复旦大学电子商务交易技术国家工程实验室",
        huaqiao: "华侨大学旅游国家级虚拟仿真实验教学中心",
        fandian: "中国饭店协会",
        gansu: "甘肃省教育厅",
        fudan1: "中国旅游协会旅游教育分会",
      },
    };
  },

  created() {
    this.getScrollingBannerList();
    this.getNewDynaml();
  },
  methods: {
    //轮播图
    getScrollingBannerList() {
      this.$http.get("ScrollingBanner/GetScrollingBannerList").then((res) => {
        if (res.success) {
          this.scrollingBannerList = res.dynamicObj;
          // console.log(this.scrollingBannerList);
        }
      });
    },
    //新闻动态
    // getNewDynaml() {
    //   this.$http.get('NewsDynamic/GetNewDynamlTop4').then(res => {
    //     if (res.success) {

    //       this.newdynallist = res.dynamicObj.map(item => ({
    //         ...item,
    //         publicationDate: this.formatDate(item.publicationDate)
    //       }));
    //       console.log(this.newdynallist);
    //     }
    //   });
    // },
    getNewDynaml() {
      this.$http.get("NewsDynamic/GetNewDynamlTop4").then((res) => {
        if (res.success) {
          const top4Items = res.dynamicObj.slice(0, 4).map((item) => ({
            ...item,
            publicationDate: this.formatDate(item.publicationDate),
          }));
          this.newdynallist = top4Items;
        }
      });
    },
    //时间转换
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const year = d.getFullYear();
      const month = ("0" + (d.getMonth() + 1)).slice(-2);
      const day = ("0" + d.getDate()).slice(-2);
      return `${year}-${month}-${day}`;
    },
  },
  mounted() {
    this.$nextTick(() => {
      const hash = this.$route.hash;
      if (hash) {
        const element = this.$el.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    });
    const wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: true,
      live: true,
      callback: function (box) {},
      scrollContainer: null,
    });
    wow.init();
  },
};
</script>
<style>
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 600px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>
<style scoped>
/* .el-carousel {
  width: 100%;
  height: 371px;
  overflow: hidden;
  position: relative;
  background-size: cover;
  background-position: center;
  display: block;
  object-position: center;

}

.carousel {
  position: relative;
  width: 1100px;
  max-width: 100%;
  margin: 0 auto;
}

.el-carousel img {
  width: 1100px;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
  position: relative;
} */

.carousel {
  position: relative;
  width: 100%;
  margin: 0 auto;
  background-color: #f2f3f5;
  height: 371px;
  overflow: hidden;
  top: 80px;
}

.el-carousel {
  width: 1100px;
  height: 371px;
  overflow: hidden;
  position: relative;
  margin: 0 auto;
  background-size: cover;
  background-position: center;
  display: block;
  object-position: center;
}

.el-carousel img {
  width: 1100px;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
  position: relative;
}
/* .carousel::before {
  content: "";
  position: absolute;
  top: 0;
  left: -120%;
  transform: translateX(30%);
  right: 0;
  bottom: 0;
  background-color: #f2f3f5;
  z-index: -1;
} */

.product_1 {
  background-color: #f5f5f5;
  padding-top: 80px;
  height: 550px;
}

.page-part-bg-color {
  background: #f2f3f5;
}

.product_2 {
  width: 100%;
  height: 550px;
  /* padding: 40px 0px; */
}

.wrap {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.ecology {
  width: 100%;
  height: 380px;
}

.cooperateSchool {
  width: 100%;
  height: auto;
}

.news {
  background: #f7f8fa;
  width: 100%;
  height: 480px;
  overflow: hidden;
  position: relative;
}

.news-list {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin: 0 auto;
  padding: 0;
}

.news-item {
  position: relative;
  width: calc(24% - 15px);
  margin: 10px;
  height: 260px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: -8px;
}

.news-list::after {
  content: "";
  display: table;
  clear: both;
}

.news-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
}

.news-info {
  padding: 10px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.news-title {
  position: relative;
  font-size: 12px;
  color: #333;
  margin-top: 10px;
  font-weight: bolder;
  white-space: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.news-date {
  font-size: 12px;
  color: #666;
  margin-right: auto;
}

.more-info-btn {
  width: 100px;
  display: inline-block;
  background-color: white;
  color: #ff8a00;
  padding: 8px 15px;
  text-decoration: none;
  border: 1px solid #ff8a00;
  border-radius: 5px;
  font-size: 18px;
  transition: all 0.3s ease;
  position: static;
}

.more-info-btn-container {
  width: 100%;
  text-align: center;
  margin-top: 30px;
}

.more-info-btn:hover {
  color: #ffffff;
  background-color: #ff8a00;
  border-color: #ff8a00;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  font-weight: bolder;
}

.image {
  width: 100%;
  height: 210px;
  background-image: url("/src/images/Ima/落版.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.text-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: auto;
  max-width: 800px;
  padding: 20px;
  box-sizing: border-box;
  margin: 0 auto;
  white-space: nowrap;
}

.company-name {
  background-color: #ff8a00;
  color: white;
  padding: 10px 20px;
  border: 1px solid #ff8a00;
  border-radius: 5px;
  text-align: center;
  font-size: 24px;
  margin-right: 20px;
  line-height: 1;
}

.expertise {
  color: #090909;
  font-size: 36px;
  text-align: left;
  margin-left: 10px;
}

.page-part-title {
  margin-bottom: 30px;
  font-size: 30px;
  padding: 20px 20px 10px 0px;
  font-weight: bolder;
  text-align: center;
  color: #333;
}

/* 产品优势 */
.product-advantages {
  display: flex;
  justify-content: space-between;
  margin-top: -40px;
  margin-left: -15px;
}

.advantage-item {
  flex-basis: calc(33.33% - 60px);
  margin: 20px;
  text-align: center;
}

.advantage-box {
  position: relative;
  padding: 25px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 370px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.advantage-content {
  background-color: rgba(255, 255, 255, 0.8);
  padding: 20px;
  border-radius: 10px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.advantage-box h4 {
  font-size: 28px;
  font-weight: bolder;
  margin-top: 13px;
  margin-bottom: 35px;
}

.advantage-box p {
  font-size: 16px;
  line-height: 1.5;
  margin: 0;
  text-align: justify;
}

.bg-img-1 {
  background-image: url("/src/images/Ima/严肃游戏教学.png");
}

.bg-img-2 {
  background-image: url("/src/images/Ima/沉浸互动教学.png");
}

.bg-img-3 {
  background-image: url("/src/images/Ima/前沿技术赋能.png");
}

/* 教育产品 */
.product-features {
  display: flex;
  justify-content: space-between;
  margin-top: -40px;
  margin-left: -15px;
}

.feature-item {
  flex-basis: calc(33.33% - 60px);
  margin: 20px;
  text-align: center;
  position: relative;
}

.feature-box {
  position: relative;
  padding: 25px;
  height: 380px;
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.feature-image {
  width: 100%;
  height: 100px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  margin-bottom: 20px;
}

.feature-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0;
  margin-bottom: auto;
}

.feature-box h4 {
  color: #282828;
  margin-top: 0;
  margin-bottom: 20px;
  text-align: center;
  font-size: 22px;
  font-weight: 600;
}

.feature-box p {
  font-size: 15px;
  line-height: 1.5;
  margin: 0;
  color: #090909;
  text-align: justify;
  font-weight: 400;
}

/* 教育产品按钮样式 */
.more-button {
  display: inline-block;
  padding: 10px 30px;
  margin-top: 20px;
  font-size: 16px;
  color: #ff8a00;
  background-color: #ffffff;
  border: 1px solid #ff8a00;
  border-radius: 30px;
  text-decoration: none;
  transition: all 0.3s ease;
  width: 80px;
  position: absolute;
  bottom: 25px;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bolder;
}

/* 按钮鼠标悬停时的样式 */
.more-button:hover {
  color: #ffffff;
  background-color: #ff8a00;
  border-color: #ff8a00;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  font-weight: bolder;
}

/* 教育产品背景图片 */
.education-bg-1 {
  background-image: url("/src/images/Ima/icon-1.png");
}

.education-bg-2 {
  background-image: url("/src/images/Ima/icon-2.png");
}

.education-bg-3 {
  background-image: url("/src/images/Ima/icon-3.png");
}

/* 合作院校-本科 */
.school-features {
  display: flex;
  flex-wrap: wrap;
  margin-top: -25px;
  justify-content: space-between;
  margin-left: -15px;
}

.school-item {
  flex-basis: calc(24.5% - 20px);
  margin: 10px 5px;
  text-align: center;
}

.school-box {
  width: 100%;
  height: 70px;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.school-box img {
  display: block;
  width: 100%;
  height: auto;
}

.school-box::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ff8a00;
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 1;
}

.school-box::before {
  content: attr(data-title);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 18px;
  text-align: center;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 2;
}

.school-box:hover::after,
.school-box:hover::before {
  opacity: 1;
  cursor: pointer;
}

/* 合作院校本科图片样式 */
.school-bg-fudan {
  background-image: url("/src/images/Ben/01.png");
}

.school-bg-huaqing {
  background-image: url("/src/images/Ben/02.png");
}

.school-bg-huanan {
  background-image: url("/src/images/Ben/03.png");
}

.school-bg-shanghaishifan {
  background-image: url("/src/images/Ben/04.png");
}

.school-bg-shenzhen {
  background-image: url("/src/images/Ben/05.png");
}

.school-bg-sanda {
  background-image: url("/src/images/Ben/06.png");
}

.school-bg-taizhou {
  background-image: url("/src/images/Ben/07.png");
}

.school-bg-zhanjiang {
  background-image: url("/src/images/Ben/08.png");
}

.school-bg-huangshan {
  background-image: url("/src/images/Ben/09.png");
}

.school-bg-liaodong {
  background-image: url("/src/images/Ben/10.png");
}

.school-bg-luoyangshifan {
  background-image: url("/src/images/Ben/11.png");
}

.school-bg-guilinlvyou {
  background-image: url("/src/images/Ben/12.png");
}

.school-bg-foshan {
  background-image: url("/src/images/Ben/13.png");
}

.school-bg-baise {
  background-image: url("/src/images/Ben/14.png");
}

.school-bg-maotai {
  background-image: url("/src/images/Ben/15.png");
}

.school-bg-chongqing {
  background-image: url("/src/images/Ben/16.png");
}

.school-bg-lijiang {
  background-image: url("/src/images/Ben/丽江文化旅游学院.png");
}
.school-bg-huaibei {
  background-image: url("/src/images/Ben/淮北师范大学.png");
}
.school-bg-kashi {
  background-image: url("/src/images/Ben/喀什大学.png");
}
.school-bg-fujian {
  background-image: url("/src/images/Ben/福建商学院.png");
}
.school-bg-jinhua {
  background-image: url("/src/images/Ben/金华职业技术大学.png");
}
.school-bg-beifang {
  background-image: url("/src/images/Ben/河北北方学院.png");
}
.school-bg-sanming {
  background-image: url("/src/images/Ben/三明学院.png");
}
.school-bg-hulunbeier {
  background-image: url("/src/images/Ben/呼伦贝尔学院.png");
}

/* 合作院校高职图片样式 */
.school-bg-shandong {
  background-image: url("/src/images/Gao/01.png");
}

.school-bg-hebei {
  background-image: url("/src/images/Gao/02.png");
}

.school-bg-shanghailvyou {
  background-image: url("/src/images/Gao/03.png");
}

.school-bg-zhangzhou {
  background-image: url("/src/images/Gao/04.png");
}

.school-bg-beijing {
  background-image: url("/src/images/Gao/05.png");
}

.school-bg-chongqinggongshang {
  background-image: url("/src/images/Gao/06.png");
}

.school-bg-guangzhou {
  background-image: url("/src/images/Gao/07.png");
}

.school-bg-hainan {
  background-image: url("/src/images/Gao/08.png");
}

.school-bg-qingdao {
  background-image: url("/src/images/Gao/09.png");
}

.school-bg-tongren {
  background-image: url("/src/images/Gao/10.png");
}

.school-bg-ningbo {
  background-size: 100%;
  background-image: url("/src/images/potato/东钱湖.png");
}

.school-bg-shanghailida {
  background-image: url("/src/images/Gao/12.png");
}

.school-bg-shanxilvyou {
  background-size: 100%;
  background-image: url("/src/images/potato/首页山西艺术.png");
}

.school-bg-yantaiwenhua {
  background-image: url("/src/images/Gao/14.png");
}

.school-bg-jilin {
  background-image: url("/src/images/Gao/jilin.jpg");
}

.school-bg-sichuanhuagong {
  background-image: url("/src/images/Gao/sichuan.jpg");
  background-size: 100%;
}
.school-bg-zhengzhoulvyou {
  background-image: url("/src/images/Gao/郑旅职业学院.jpg");
  background-size: 100%;
}

.school-bg-guangxishangwu {
  background-image: url("/src/images/Gao/广西国际商务职业技术学院.png");
}
.school-bg-tianjing {
  background-image: url("/src/images/Gao/天津职业大学.png");
}
.school-bg-anhuigongshang {
  background-image: url("/src/images/Gao/安徽工商职业学院.png");
}
.school-bg-hainanruanjian {
  background-image: url("/src/images/Gao/海南软件职业技术学院.png");
}
.school-bg-wuhanjiaotong {
  background-image: url("/src/images/Gao/武汉交通职业学院.png");
}
.school-bg-bozhou {
  background-image: url("/src/images/Gao/亳州职业技术学院.png");
}
.school-bg-shanghaijiguang {
  background-image: url("/src/images/Gao/上海济光职业技术学院.png");
}
.school-bg-shanghaizhenhua {
  background-image: url("/src/images/Gao/上海市振华外经职业技术学院.png");
}
.school-bg-xiamenhaiyang {
  background-image: url("/src/images/Gao/厦门海洋职业技术学院.png");
}
.school-bg-fujianxinxi {
  background-image: url("/src/images/Gao/福建信息职业技术学院.png");
}
.school-bg-guangdongkexue {
  background-image: url("/src/images/Gao/广东科学技术职业学院.png");
}
.school-bg-taizhoukeji {
  background-image: url("/src/images/Gao/台州科技学院.png");
}

.school-features {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.school-item {
  flex-basis: calc(24.5% - 40px);
  margin: 10px 18px;
  text-align: center;
}

/* 合作生态 */
.ecology-features {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: -30px;
}

.ecology-item {
  flex-basis: calc(33.3333% - 10px);
  margin: 15px 0px;
  box-sizing: border-box;
}

.ecology-item:nth-child(4),
.ecology-item:nth-child(5) {
  flex: 1 0 calc(49% - 10px);
  margin: 10px 5px;
  transform: translateX(40px);
}
.ecology-item:nth-child(2) {
  transform: translateX(25px);
}
.ecology-item:nth-child(3) {
  transform: translateX(50px);
}

.ecology-item:nth-child(7),
.ecology-item:nth-child(8) {
  transform: translateX(-45px);
}

.ecology-item:nth-child(8) {
  transform: translateX(-90px);
}

.ecology-box {
  width: 80%;
  height: 65px;
  background-color: #f6f8fa;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border: 1px solid #ddd;
  position: relative;
}
.ecology-box::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ff8a00;
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 1;
}

.ecology-box::before {
  content: attr(data-title);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-size: 18px;
  text-align: center;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 2;
}

.ecology-box:hover::after,
.ecology-box:hover::before {
  opacity: 1;
  cursor: pointer;
}
.ecology-bg-lvyoubu {
  background-image: url("/src/images/Ima/01.png");
}

.ecology-bg-jiaoyubu {
  background-image: url("/src/images/Ima/02.png");
}

.ecology-bg-fujian {
  background-image: url("/src/images/Ima/08.png");
}

.ecology-bg-fudan2 {
  background-image: url("/src/images/Ima/04.png");
}

.ecology-bg-huaqiao {
  background-image: url("/src/images/Ima/05.png");
}

.ecology-bg-fandian {
  background-image: url("/src/images/Ima/06.png");
}

.ecology-bg-gansu {
  background-image: url("/src/images/Ima/07.png");
}

.ecology-bg-fudan1 {
  background-image: url("/src/images/Ima/微信图片_20250305112810.png");
}
</style>
